<template>
  <div>
    <div class="home-rigth-fixbox">
      <!-- <div class="returnTop-box" v-if="showTop" @click="returnTopFn">
        <el-image style="width: 17px; height: 20px" :src="arrowsUrl"></el-image>
        <div>返回顶部</div>
      </div> -->
       <el-image style="width: 80px; height:76px;cursor:pointer" :src="arrowsUrl" @click="returnTopFn"></el-image>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showTop: false,
      arrowsUrl: require("@/assets/imgs/home/top.png"),
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll() {
      let scrollTop = window.scrollY;
      if (scrollTop > 350) {
        this.showTop = true;
      } else {
        this.showTop = false;
      }
    },
    returnTopFn() {
      let number = window.scrollY;
      let timer = setInterval(() => {
        number -= 200;
        window.scrollTo(0, number);
        if (number <= 0) {
          window.clearInterval(timer);
        }
      }, 10);
    },
  },
};
</script>

<style lang="less" scoped>
.home-rigth-fixbox {
  position: fixed;
  right: 20px;
  bottom: 100px;
  // background-color: #1088fe;
  // width: 80px;
  z-index: 999999;
  .returnTop-box {
    width: 80px;
    height: 75px;
    display: flex;
    flex-direction: column;
    //   background: #0CB2FD;
    background: linear-gradient(90deg, #35b4fe 0%, #0f87fe 100%);
    font-size: 15px;
    //   color: #fff;
    color: #fff;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}
</style>